/*
 * @Author: your name
 * @Date: 2021-11-10 23:27:16
 * @LastEditTime: 2022-05-21 14:34:16
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\plugins\index.js
 */

import Vue from 'vue'

/**
 * 安装vant组件
 */
import './vant'

/**
 * 安装图片懒加载
 */
import './lazyload'

/**
 * 使用echarts图表
 */
import './echarts'

/**
 * linq 函数方法
 */
import '@/utils/linq-service'

/**
 * 全局配置
 */
import config from '@/common/config'

/**
 * 弹框工具
 */
import alertService from '@/utils/alert-service'

/**
 * app系统方法
 */
import appService from '@/utils/app-service'

/**
 * 水印
 */
import watermarkHelper from './watermark'

/**
 * 工具
 */
import DateTimeService from '@/utils/computed'
import CommonService from '@/utils/common-service'
import ConvertService from '@/utils/convert-service'
import CryptoService from '@/utils/crypto-service'
import RuleValidate from '@/utils/rule-validate'
import LogService from '@/utils/log-service'

/**
 * 安装api接口
 */
import apiList from '@/api/api-hub'

/**
 * 缓存工具
 */
import storage from '@/utils/storage-service'

/**
 * 全局挂载-api请求
 * @param {*} Vue 
 * @returns 
 */
const installApi = function (Vue) {
  if (installApi.installed) return

  installApi.installed = true
  Object.defineProperties(Vue.prototype, {
    $api: {
      get () {
        return apiList
      },
      enumerable: false, // 不可枚举
      configurable: false // 不可重写
    }
  })
}

/**
 * 全局挂载-缓存工具
 * @param {*} Vue 
 * @returns 
 */
const installStorage = function (Vue) {
    if (installStorage.installed) return

    installStorage.installed = true
    Object.defineProperties(Vue.prototype, {
        $storage: {
        get () {
            return storage
        },
        enumerable: false, // 不可枚举
        configurable: false // 不可重写
        }
    })
}

/**
 * 全局挂载-全局配置
 * @param {*} Vue 
 * @returns 
 */
 const installConfig = function (Vue) {
  if (installConfig.installed) return

  installConfig.installed = true
  Object.defineProperties(Vue.prototype, {
      $config: {
      get () {
          return config
      },
      enumerable: false, // 不可枚举
      configurable: false // 不可重写
      }
  })
}

/**
 * 全局挂载-弹框
 * @param {*} Vue 
 * @returns 
 */
 const installAlert = function (Vue) {
  if (installAlert.installed) return

  installAlert.installed = true
  Object.defineProperties(Vue.prototype, {
      $alert: {
      get () {
        return alertService
      },
      enumerable: false, // 不可枚举
      configurable: false // 不可重写
      }
  })
}

/**
 * 全局挂载-工具
 * @param {*} Vue 
 * @returns 
 */
 const installUtils = function (Vue) {
  if (installUtils.installed) return

  installUtils.installed = true
  Object.defineProperties(Vue.prototype, {
      $utils: {
      get () {
        return {
          DateTime: DateTimeService,
          Convert: ConvertService,
          Crypto: CryptoService,
          common: CommonService,
          RegExp: RuleValidate,
          Watermark: watermarkHelper,
        }
      },
      enumerable: false, // 不可枚举
      configurable: false // 不可重写
      }
  })
}

/**
 * 全局挂载-系统方法
 * @param {*} Vue 
 * @returns 
 */
 const installApp = function (Vue) {
  if (installApp.installed) return

  installApp.installed = true
  Object.defineProperties(Vue.prototype, {
      $app: {
      get () {
        return appService
      },
      enumerable: false, // 不可枚举
      configurable: false // 不可重写
      }
  })
}

Vue.use(installStorage)
Vue.use(installApi)
Vue.use(installConfig)
Vue.use(installAlert)
Vue.use(installUtils)
Vue.use(installApp)